/** @format */

import React from "react";
import Login from "./Login";

export default function Cadastro() {
  return <Login modoInicial="cadastro" />;
}
